module.exports = __webpack_public_path__ + "img/userauthentication.8cfbc845.jpg";